(function ($) {
  'use strict'
  Drupal.behaviors.sliderComponentCarousel = {
    attach: function (context, settings) {

      var sliderOptionsSecond = {
        slidesPerView: 'auto',
        spaceBetween: 16,

        breakpoints: {
          1025: {
            allowTouchMove: false,
            centeredSlides: true,
            spaceBetween: 32,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        }
      };
	  
    var swiperCarousel = new Swiper('.paragraph--carousel .swiper', sliderOptionsSecond);
    const mainSliderCarousel = $('.paragraph--carousel', context)

      if (mainSliderCarousel.length) {
        mainSliderCarousel.each(function() {
          const allSlides = $(this).find('.swiper-slide');
          const allControls = $(this).find('.swiper-controls');
          if(allSlides.length <= 2) {
          allControls.addClass("swiper-controls--remove");
          }
        });
      }
    }
  };

}) (jQuery)










